/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { EDITORS } from 'cio/utils/editor-utils';
import AuthService from 'cio/services/auth';

interface StartFromScratchButtonArgs {
  editorName: keyof typeof EDITORS;
  onStartFromScratch: (editorName: string) => unknown;
  tag?: string;
  v2?: boolean;
  isSelected?: boolean;
  isExternal?: boolean;
}

export default class StartFromScratchButton extends Component<StartFromScratchButtonArgs> {
  @service auth!: AuthService;

  get editor() {
    let editorInfo = EDITORS[this.args.editorName];

    if (this.args.editorName === 'html' && (this.auth.user?.userFlags.parcel_editor_on ?? false)) {
      return {
        ...editorInfo,
        description: 'Build emails from code with developer tools like syntax autocomplete and inspect mode.',
      };
    }

    return editorInfo;
  }

  @action
  onClick() {
    this.args.onStartFromScratch(this.args.editorName);
  }

  get isInApp() {
    return ['in_app_classic', 'in_app_visual'].includes(this.args.editorName);
  }
}
